import * as React from "react";
import { render } from "react-dom";
import { App } from "./core/App";

const rootEl = document.getElementById("root");

render(<App />, rootEl);
